<template>
  <div class="empty-box">
    <el-image class="empty-img" :src="currentImg" fit="contain"></el-image>
    <div class="empty-tips">{{ tips }}</div>
  </div>
</template>

<script>
export default {
  name: 'm-empty',
  props: {
    imgUrl: '',
    tips: {
      type: String,
      default: '暂无数据',
    },
  },
  data() {
    return {
      defaultImg: require('@/assets/img/empty.png'),
    }
  },
  computed: {
    currentImg: {
      get() {
        if (!this.imgUrl) {
          return this.defaultImg
        }
        return this.imgUrl
      },
    },
  },
}
</script>
<style lang="scss" scoped>
.empty-box {
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .empty-img {
    width: 150px;
    height: 100%;
  }
}
</style>
